import { Component, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { helper } from 'src/environments/helper';
import { IProiect } from '../../proiecte.interface';
import { ProiecteService } from '../../proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { IInchidereForm, IInchidereUpdatePayload } from './modal-inchidere-proiect.interface';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-modal-inchidere-proiect',
    templateUrl: './modal-inchidere-proiect.component.html',
    styleUrls: ['./modal-inchidere-proiect.component.scss']
})
export class ModalInchidereProiectComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;
    editorConfig!: AngularEditorConfig;

    isLoading = false;
    uploading = false;

    passedProiectId!: number;

    form: FormGroup = new FormGroup({
        garantie: new FormControl('', [Validators.required]),
        observatii: new FormControl('', [Validators.required]),
        files: this.fb.array([]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            proiect: IProiect,
            departamenteActive: Generic[],
            sectiuni: Generic[],
        },
        private dialogRef: MatDialogRef<ModalInchidereProiectComponent>,
        private notificationService: NotificationService,
        private proiecteService: ProiecteService,
        private fb: FormBuilder,
    ) { }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();

        this.passedProiectId = this.data.proiect.id_proiect;
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { garantie, observatii, files } = this.form.value as IInchidereForm;
        const payload: IInchidereUpdatePayload = {
            garantie: garantie.toISOString().split('T')[0],
            observatii,
            files
        };

        // console.log('Payload inchidere proiect', payload);

        this.proiecteService
            .inchidereProiect(this.passedProiectId, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    addFile(event: any, key: 'file') {
        event.eventPreventDefault = true;
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploading = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.proiecteService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.form.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            console.log(files);

                            this.uploading = false;
                            this.notificationService.warningSwal(
                                this.successTitle,
                                helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                this.successIcon,
                            );
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading = false;

                    let msg;
                    try {
                        // try to catch the message from server
                        msg = result.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
        }
    }

    removeFile(index: number) {
        const files = this.form.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }
}
